// extracted by mini-css-extract-plugin
export var bodyFont = "desktop-module--body-font--66e63";
export var cities_wrapper = "desktop-module--cities_wrapper--13961";
export var city_selector = "desktop-module--city_selector--0e96f";
export var content_list = "desktop-module--content_list--76b5b";
export var desktop_onboarding = "desktop-module--desktop_onboarding--e236c";
export var header_active = "desktop-module--header_active--cb047";
export var headings = "desktop-module--headings--5f5f9";
export var hero_text = "desktop-module--hero_text--ea0dd";
export var home_page_picker = "desktop-module--home_page_picker--64346";
export var no_border = "desktop-module--no_border--56c8c";
export var search_button = "desktop-module--search_button--4eee0";
export var team_size_selector = "desktop-module--team_size_selector--78b4a";
export var titleFont = "desktop-module--title-font--b26d5";